import * as React from 'react';
import Ingredients from './Ingredients';
import DeleteMeal from './DeleteMeal';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const MealCard = ({ meal, toggleMealCard, portions, user, deleteMeal }) => {
  console.log(meal.description)
  const imagePath = "https://meals.shosenfeld.com/images/"+meal.title+"-image.jpg";

  return (
    <div onClose={toggleMealCard} className='popup'>
      <div className='popup_inner'>
        <div className="food-pic-div height30">
        <img className="image-max" src={imagePath} alt='Mealimage' maxheight="180" maxwidth="320"></img>
          {/* <img className="image-max" src={'https://img.chefkoch-cdn.de/rezepte/1623741269600107/bilder/624361/crop-960x720/perfekte-pommes-frites.jpg'} alt='sad' /> */}
        </div>
        <div className="height70">
          <div className="flex vertical-center margin10">
            <h3>{meal.title}</h3>
            <IconButton aria-label="close" className="closeButton" onClick={toggleMealCard}>
              <CloseIcon />
            </IconButton>
          </div>
          <Ingredients ingredients={meal.ingredients} portions={portions}></Ingredients>
          
          <p></p>
          <h4>Description</h4>
          <div className="description">{meal.description}</div>
          {user.sub === meal.creatorId ? <DeleteMeal className="width10" id={meal.id} deleteMeal={deleteMeal} ></DeleteMeal> : <div className="width10"></div>}
        </div>
      </div>
    </div>
  );
}

export default MealCard